export const PRISTINE = 1
export const JUNTOS = 2
export const ELEGANT = 3
export const EVENTUALLY = 4
export const JUSTSAYING = 5
